import { COLORS } from '@ds/tokens/legacy/colors'
import { StylesConfig } from 'react-select'

type Args = {
	minHeight?: string
}

export const primaryV2SelectStyles = (
	args?: Args,
): StylesConfig<any, boolean, any> => {
	const { minHeight } = args || {}

	return {
		container: () => ({
			minHeight: minHeight || '36px',
		}),
		control: (_, state) => ({
			minHeight: minHeight || '36px',
			borderColor: state.isFocused ? 'transparent' : COLORS.background[9],
		}),
	}
}
